import { ReactNode } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Box } from "@mui/material";

interface ParallaxSectionProps {
  children: ReactNode;
}

export const ParallaxSection = ({ children }: ParallaxSectionProps) => {
  const { scrollYProgress } = useScroll();
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "50%"]);

  return (
    <Box className="parallax-container">
      <motion.div style={{ y }}>{children}</motion.div>
    </Box>
  );
};
